module.exports = __webpack_public_path__ + "static/alex-craven-vfp-tweet-3f4e70b799da01a1c5d439e4ada36f48.png";